import { render } from "./mat-checkbox.vue?vue&type=template&id=c8871188&lang=true"
import script from "./mat-checkbox.vue?vue&type=script&lang=js"
export * from "./mat-checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__